import { useContext } from "react";
import { useQueryClient } from "@tanstack/react-query";
// Context
import { AlertNotificationContext } from "../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../hooks/useCheckAPI";
// State Import
import { useSaveStaffOrder } from "../hooks/useSaveStaffOrder";
// MUI
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export const OrderReasonSelect = ({
  reasonCode,
  reasons,
  person,
  order,
  size,
  fullWidth,
  poNo,
}) => {
  const queryClient = useQueryClient();
  const { setAlertNotification } = useContext(AlertNotificationContext);

  // Save order
  const {
    mutate: saveOrder,
    isSuccess: saveSuccess,
    data: saveData,
  } = useSaveStaffOrder();

  // Do this on save order success
  const saveSuccessFunc = () => {
    setAlertNotification({
      message: `Order Reason Updated`,
      severity: "info",
    });
    queryClient.invalidateQueries({
      queryKey: ["draftOrderStaff", order, person],
    });
  };

  // Do this on save order error
  const saveErrorFunc = () => {
    setAlertNotification({
      message: `Error: ${saveData.data.status}: ${saveData.data.statusText}`,
      severity: "error",
    });
  };

  // Hook to check the BC API for errors
  useCheckAPI(
    saveSuccess,
    saveData,
    saveData?.data?.status,
    saveSuccessFunc,
    saveErrorFunc,
  );

  //   Change Order Reason
  const handleOrderReasonChange = (event) => {
    saveOrder({
      data: {
        filter: { orderNo: order, staffLineNo: person },
        lines: [],
        reason: event.target.value,
        staffpoNo: poNo,
      },
    });
  };

  return (
    <FormControl sx={{ minWidth: 200 }} size={size} fullWidth={fullWidth}>
      <InputLabel id="order-reason-select-label">Reason</InputLabel>
      <Select
        labelId="order-reason-select-label"
        id="order-reason-select"
        value={reasonCode || ""}
        label="Reason"
        onChange={handleOrderReasonChange}
      >
        {reasons?.map((reason) => (
          <MenuItem key={reason.code} value={reason.code}>
            {reason.desc}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
